export const inputProps = {
  id: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number],
    default: null,
  },
  type: {
    type: [String, Object],
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: '',
  },
  block: {
    type: Boolean,
    default: false,
  },
  currency: {
    type: Boolean,
    default: false,
  },
  trade: {
    type: Boolean,
    default: false,
  },
  plain: {
    type: Boolean,
    default: false,
  },
  allowBlank: {
    type: Boolean,
    default: false,
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  decimal: {
    type: String,
    default: '.',
  },
  thousands: {
    type: String,
    default: ',',
  },
  precision: {
    type: Number,
    default: 2,
  },
  text: {
    type: String,
    default: ''
  },
  focused: {
    type: Boolean,
    default: false
  }
}
